import React, { useEffect, useState } from "react";
import styles from "./LogData.module.css";
import { CommentEntry } from "./CommentEntry";
import { useDispatch } from "react-redux";
import { updateComment } from "../../../../../../../redux/slices/alarmLogSlice";
import proxy from "proxy";

const LogData = ({ data, projectId }) => {
  const [comment, setComment] = useState(data.comment || "");
  const dispatch = useDispatch();

  useEffect(() => {
    setComment(data.comment || "");
  }, [data.comment]);

  const handleSubmitComment = async (newComment) => {
    try {
      const response = await fetch(`${proxy}/api/setAlarmComment`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({
          id: data._id,
          projectId,
          comment: newComment,
        }),
      });
      if (response.ok) {
        setComment(newComment);
        dispatch(updateComment({ id: data._id, comment: newComment }));
      } else {
        console.error('Failed to update comment');
      }
    } catch (error) {
      console.error('Error updating comment:', error);
    }
  };

  const currentTime = new Date();
  const responsetime = new Date(data.time);
  const timeDifference = Math.floor((currentTime - responsetime) / 60000);
  const time = new Date(data.time);
  const istTime = new Date(
    time.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
  );

  const hours = istTime.getHours();
  const minutes = istTime.getMinutes();
  const seconds = istTime.getSeconds();

  // Format the time as a string (e.g., "10:23:25")
  const newTime = `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  const newDate = time.toLocaleDateString();

  const formatTimeDifference = (minutes) => {
    if (minutes < 60) {
      return minutes === 1 ? "1 minute ago" : `${minutes} minutes ago`;
    } else if (minutes < 1440) {
      // 1440 minutes in a day (24 hours)
      const hours = Math.floor(minutes / 60);
      return hours === 1 ? "1 hour ago" : `${hours} hours ago`;
    } else {
      const days = Math.floor(minutes / 1440);
      return days === 1 ? "1 day ago" : `${days} days ago`;
    }
  };

  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <div className={styles.bodyContainer}>
          <div className={styles.logInfo}>
            <div className={styles.alarmName}>{data.alarmName}</div>
            <div className={styles.time}>
              {timeDifference === 0
                ? "Just Now"
                : formatTimeDifference(timeDifference)}
            </div>
          </div>
          <div className={styles.valueWrapper}>
            <div className={styles.value}>value:</div>
            <div className={styles.cardBody}>{data.value}</div>
          </div>
        </div>
        <div className={styles.timeInfo}>
          <div className={styles.logTime}>{newDate}</div>
          <div className={styles.logTime}>{newTime}</div>
        </div>
      </div>
      <div className={styles.comments}>
        <div>
          Comment: {data.comment ? data.comment : "No comment provided"}
        </div>
        {!data.comment && (
          <CommentEntry
            onSubmit={handleSubmitComment}
            presetComments={["Mechanical Issue", "Electrical Issue", "Tooling/Change Over", "Material Shortage", "Manpower", "Planning", "Power Outage", "QA Hold","Acknowledged", "Investigating", "Resolved"]}
          />
        )}
      </div>
    </div>
  );
};

export default LogData;
